import { ToggleGroup } from '../../Form';
import { FormControlSizes } from '../../Form/types';
import { Text } from '../../Text';
import type { CurrencyControlsProps } from './CurrencyControlsProps';
import { getVariant } from './utils';

export function CurrencyButtons<KeyType extends string = string>({
  disabled,
  currencyOptions,
  currency,
  side,
  currencyButtonVariant,
  suffixColor,
  handleChangeCurrency,
  'data-testid': dataTestId,
}: CurrencyControlsProps<KeyType>) {
  return (
    <ToggleGroup<KeyType>
      options={currencyOptions.map((co, i) => ({
        value: co.currency,
        displayName: suffixColor ? <Text color={suffixColor}>{co.label}</Text> : co.label,
        buttonVariant: currencyButtonVariant ?? getVariant(side),
        disabled,
        testId: dataTestId ? `${dataTestId}-${i}` : undefined,
      }))}
      onChange={handleChangeCurrency}
      value={currency}
      size={FormControlSizes.Small}
      boxProps={{ alignSelf: 'center', lineHeight: 1 }}
      data-testid={dataTestId}
    />
  );
}
